import Vue from "vue"

export default {
  mounted: function () {
    var vm = this
    var analytics_js
    var gtag_id
    var ga_id

    // Move this to nuxt config or somewhere cleaner
    if (Vue.config.devtools) {
      if (process.env.GOOGLE_ANALYTICS_ENV == "debug") {
        analytics_js = "analytics_debug.js"
        window.ga_debug = { trace: true }
      } else {
        analytics_js = "analytics.js"
      }
      gtag_id = "GTM-KKDFZ3L"
      ga_id = "UA-119558507-3"
    } else {
      analytics_js = "analytics.js"
      gtag_id = "GTM-PRLHTW7"
      ga_id = "UA-119558507-1"
    }

    ;(function (w, d, s, l, i) {
      w[l] = w[l] || []
      w[l].push({
        "gtm.start": new Date().getTime(),
        event: "gtm.js",
      })
      var f = d.getElementsByTagName(s)[0]
      var j = d.createElement(s)
      var dl = l != "dataLayer" ? "&l=" + l : ""
      j.async = true
      j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl
      f.parentNode.insertBefore(j, f)
    })(window, document, "script", "dataLayer", gtag_id)
    ;(function (i, s, o, g, r, a, m) {
      i["GoogleAnalyticsObject"] = r
      ;(i[r] =
        i[r] ||
        function () {
          ;(i[r].q = i[r].q || []).push(arguments)
        }),
        (i[r].l = 1 * new Date())
      ;(a = s.createElement(o)), (m = s.getElementsByTagName(o)[0])
      a.async = 1
      a.src = g
      m.parentNode.insertBefore(a, m)
    })(
      window,
      document,
      "script",
      `https://www.google-analytics.com/${analytics_js}`,
      "ga"
    )

    ga(
      function (tracker) {
        var clientId = tracker.get("clientId")

        this.$cookies.set("client-id", clientId)
      }.bind(this)
    )
    ga("create", ga_id, "auto")
    ga("require", "ecommerce")
  },
}
